import { format, addDays } from 'date-fns';

export function utcDateTimeToLocal(date, dateFormat = 'yyyy-MM-dd HH:mm', addDaysToDate = null) {
  if (!date) {
    return null;
  }

  try {
    if (addDaysToDate) {
      return format(addDays(new Date(date), addDaysToDate), dateFormat);
    }

    return format(new Date(date), dateFormat);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return null;
  }
}

